export const helpUrls = {
  customerSupport: '#',
  customerSupportZh: '#',
  contactEmail: '#',
  discord: '#',
  telegram: '#',
  github: '#',
  projectSerum: '#',
  developerResources: '#',
  solanaBeach: '#',
};
